import { Pipe, PipeTransform } from '@angular/core';

const NUMBER_FORMAT = /(-?\d+)(\d{3})/;

@Pipe({ name: 'slshare' })
export class SLSharePipe implements PipeTransform {
 
  transform(value: string | number, ...args: any[]) {
    if (!value) {
      return '';
    }
    
    let s = value.toString();

    while (NUMBER_FORMAT.test(s)) {
      s = s.replace(NUMBER_FORMAT, '$1.$2');
    }
  
    return s;
  }
}
